import React from 'react';
import { Modal } from 'react-bootstrap';

import { useApiQuery } from '../../hooks/useApiQuery';
import { usePagination } from '../../hooks/usePagination';
import { list as listProducts } from '../../apis/products';

import { SearchModalForm } from './SearchModalForm';
import { SearchItemList } from './SearchItemList';
import { EmptyCard } from '../common/ui/EmptyCard';

export const SearchModal = ({ show, onHide, onAddItem, addItemText }) => {
    const initialPagination = {
        category: '',
        filter: '',
        size: 5,
        page: 1
    };

    const {
        pagination,
        setPagination,
        handlers: paginationHandlers
    } = usePagination(initialPagination);

    const products = useApiQuery(listProducts, pagination);

    const handleSearch = ({ filter, category }) => {
        setPagination({ filter, category, size: 5, page: 1 });
    };

    const handleReset = () => {
        setPagination({ filter: '', category: '', size: 5, page: 1 });
    };

    const handleHide = () => {
        handleReset();
        onHide();
    };

    return (
        <Modal size="lg" show={show} onHide={handleHide} aria-labelledby="search-modal-lg">
            <Modal.Header closeButton>
                <Modal.Title id="search-modal-lg">Search Gifts</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SearchModalForm onSubmit={handleSearch} />
                {products.isLoading || products.data.records.length > 0 ? (
                    <SearchItemList
                        className="mt-3"
                        {...products}
                        {...paginationHandlers}
                        {...{ onAddItem, addItemText }}
                    />
                ) : (
                    <EmptyCard icon="gift" text="Gifts not found">
                        <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={handleReset}>
                            Clear filters
                        </button>
                    </EmptyCard>
                )}
            </Modal.Body>
        </Modal>
    );
};
